import { Expose, Type } from 'class-transformer';
import { AuthorizationRules } from 'common/constants';
import { NotificationTypeEnum } from 'common/constants/enum';
import { CommonParamInput } from 'common/repositories/common.model';

export class NotificationBadgeModel {
  color: string;
  background_color: string;
  count: number;
}

export class NotificationItemModel {
  en: string;
  id: string;
}

export class NotificationMetadataModel {
  id: string;
  acl: string;
}

export class NotificationDataModel {
  body: NotificationItemModel;
  subject: NotificationItemModel;
  type: NotificationTypeEnum;
  metadata: NotificationMetadataModel;
}

export class NotificationLiteModel {
  id: string;
  data: NotificationDataModel;

  @Expose({ name: 'read_at' })
  @Type(() => Date)
  readAt: Date;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;
}

export class UnreadNotificationCountModel {
  @Type(() => Number)
  count: number;
}

// Input

export class getNotificationsInput {
  params: CommonParamInput;
}

export class getNotificationInput {
  acl: AuthorizationRules;
}

export class ReadNotificationInput {
  id: string;
}
